var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 29.25H21.45V17.55H17.55V29.25ZM19.5 13.65C20.0525 13.65 20.5159 13.4628 20.8903 13.0884C21.2647 12.714 21.4513 12.2512 21.45 11.7C21.45 11.1475 21.2628 10.6847 20.8884 10.3116C20.514 9.9385 20.0512 9.7513 19.5 9.75C18.9475 9.75 18.4847 9.9372 18.1116 10.3116C17.7385 10.686 17.5513 11.1488 17.55 11.7C17.55 12.2525 17.7372 12.7159 18.1116 13.0903C18.486 13.4647 18.9488 13.6513 19.5 13.65ZM19.5 39C16.8025 39 14.2675 38.4878 11.895 37.4634C9.5225 36.439 7.45875 35.0499 5.70375 33.2962C3.94875 31.5412 2.5597 29.4775 1.5366 27.105C0.5135 24.7325 0.0013 22.1975 0 19.5C0 16.8025 0.5122 14.2675 1.5366 11.895C2.561 9.5225 3.95005 7.45875 5.70375 5.70375C7.45875 3.94875 9.5225 2.5597 11.895 1.5366C14.2675 0.5135 16.8025 0.0013 19.5 0C22.1975 0 24.7325 0.5122 27.105 1.5366C29.4775 2.561 31.5412 3.95005 33.2962 5.70375C35.0512 7.45875 36.4409 9.5225 37.4653 11.895C38.4897 14.2675 39.0013 16.8025 39 19.5C39 22.1975 38.4878 24.7325 37.4634 27.105C36.439 29.4775 35.0499 31.5412 33.2962 33.2962C31.5412 35.0512 29.4775 36.4409 27.105 37.4653C24.7325 38.4897 22.1975 39.0013 19.5 39Z",
    fill: "#E0861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.7f7b87259b28daa87d63f80989f52fd6.svg";
export { ForwardRef as ReactComponent };